import {
    Modal,
    ConfigProvider,
  } from "antd";


export const DeleteConfirmationModal = ({
    onConfirmDelete,
    onCancel,
    visible,
    title,
    text,
  }) => {
    return (
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: "#f33",
            //colorBgContainer: "#88ff88",
          },
          components: {
            Modal: {
              titleColor: "#f00",
            },
          },
        }}
      >
        <Modal
          title={title}
          open={visible}
          onOk={onConfirmDelete}
          onCancel={onCancel}
        >
          <p>{text}</p>
        </Modal>
      </ConfigProvider>
    );
  };

  export const OKConfirmationModal = ({
    onConfirmDelete,
    onCancel,
    visible,
    title,
    text,
  }) => {
    return (
      <ConfigProvider
        theme={{
          token: {
            //colorPrimary: "#f33",
            //colorBgContainer: "#88ff88",
          },
          components: {
            Modal: {
              //titleColor: "#f00",
            },
          },
        }}
      >
        <Modal
          title={title}
          open={visible}
          onOk={onConfirmDelete}
          onCancel={onCancel}
        >
          <p>{text}</p>
        </Modal>
      </ConfigProvider>
    );
  };